import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("dcms_token");
    localStorage.removeItem("dcms_user");
    navigate("/signin", { replace: true });
  }, [navigate]);
  return null;
};

export default Logout;
